import { Factory } from 'rosie';

Factory.define('PhoneCallObserverNotification');

Factory.define('PhoneCallObserverNotificationWithDefaults')
  .extend('PhoneCallObserverNotification')
  .attr('id', 'some-notification-id')
  .attr('message', 'You are now listening in on the call.')
  .attr('recipient', 'OBSERVER');
